import { render, staticRenderFns } from "./storeprice_changes.vue?vue&type=template&id=0e6b08ca&"
import script from "./storeprice_changes.vue?vue&type=script&lang=js&"
export * from "./storeprice_changes.vue?vue&type=script&lang=js&"
import style0 from "./storeprice_changes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports